<!-- Clickable climate line -->
<div class="flex items-center gap-1 cursor-pointer min-w-0" (click)="pickerClick.emit()">
  <span class="text-sm font-medium text-primary underline underline-offset-2 truncate max-w-[200px]">
    @if (selectedClimateType) {
      {{ 'profile.addresses.climate-types.' + selectedClimateType | translate }}
    } @else if (myClimateType) {
      {{ 'profile.addresses.climate-types.' + myClimateType | translate }}
    } @else {
      {{ 'calendar.climate.myClimate' | translate }}
    }
  </span>
  <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-primary shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
</div>
